
import React from "react";
import Header from "../components/home/Header";
import Footer from "../components/home/Footer";
import BlogSub from "../components/Blog/BlogSub";


function BlogSubPage() {
  return (
    <div>
      <Header />
      <BlogSub />
      <Footer />
    </div>
  );
}

export default BlogSubPage;
